/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetApplicationVersionAdoptionPathParams = NonNullable<
  operations['getApplicationVersionAdoption']['parameters']['path']
>;

export interface Input extends GetApplicationVersionAdoptionPathParams {
  apiVersion?: string;
}

export async function getApplicationVersionAdoption(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/applications/{applicationKey}/version-adoption', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
